module.exports = __webpack_public_path__ + "img/an.356f0d97.svg";